import * as types from './types';

const fetchUserNotifications = () => ({
  type: types.FETCH_USER_NOTIFICATIONS,
  payload: { isLoading: true, error: null }
});

const fetchUserNotificationsSuccess = userNotifications => ({
  type: types.FETCH_USER_NOTIFICATIONS_SUCCESS,
  payload: { entity: userNotifications, isLoading: false }
});

const fetchUserNotificationsError = error => ({
  type: types.FETCH_USER_NOTIFICATIONS_ERROR,
  payload: { error, isLoading: false }
});

const dismissUserNotification = () => ({
  type: types.DISMISS_USER_NOTIFICATION,
  payload: {
    isLoading: true,
    error: null
  }
});

const dismissUserNotificationSuccess = () => ({
  type: types.DISMISS_USER_NOTIFICATION_SUCCESS,
  payload: {
    isLoading: false,
    isDismissed: true
  }
});

const dismissUserNotificationError = error => ({
  type: types.DISMISS_USER_NOTIFICATION_ERROR,
  payload: { error, isLoading: false }
});

export {
  fetchUserNotifications,
  fetchUserNotificationsSuccess,
  fetchUserNotificationsError,
  dismissUserNotificationError,
  dismissUserNotification,
  dismissUserNotificationSuccess
};
